import React from "react";
import { NavLink} from 'react-router-dom';

export default (props) => {
    return (
        <ul className="menu-content-nav">
            <NavLink to="/orders/contractor/all"> Все</NavLink>
            <NavLink exact to="/orders/contractor" className={(!props.id) ? 'active' : ''}> Мои (все)</NavLink>
            <NavLink to="/orders/contractor/for_me"> Отобранные</NavLink>
            <NavLink to="/orders/contractor/place"> Поиск исполнителя</NavLink>
            <NavLink to="/orders/contractor/wait_me"> Ждут исполнения</NavLink>
            <NavLink to="/orders/contractor/wait_customer"> Ждут приемки</NavLink>
            <NavLink to="/orders/contractor/finish"> Выполненные</NavLink>
            {/* <NavLink to="/orders/contractor/7"> Арбитраж</NavLink> */}
            <NavLink to="/orders/contractor/complaint"> Претензия</NavLink>
            
        </ul>
    )
}


// WEBPACK FOOTER //
// ./src/components/Orders/ExecutorNav.js